import { GameType } from '@modules/games/Game/constants/availableGames';
import { ROUTE, generateUrl, routes } from '@common/routes/Routes';

// Generate game routes dynamically using GameType enum
export const GAME_ROUTES_MAP = Object.keys(GameType).reduce((acc, key) => {
	const gameType = GameType[key as keyof typeof GameType];

	if (gameType === GameType.SLOTS) {
		acc[gameType] = generateUrl(ROUTE.slotCasino, {});
	} else if (gameType === GameType.SPORTS) {
		// Sports might have different route handling - skip for now
		return acc;
	} else {
		// InHouse games use /casino/{gameType} pattern
		acc[gameType] = generateUrl(ROUTE.slotCasinoGame, { slug: gameType });
	}

	return acc;
}, {} as Record<GameType, string>);

// Dynamically get all non-slots, non-sports game routes
export const INHOUSE_GAME_ROUTES = Object.keys(GameType)
	.filter((key) => {
		const gameType = GameType[key as keyof typeof GameType];
		return gameType !== GameType.SLOTS && gameType !== GameType.SPORTS;
	})
	.map((key) => GAME_ROUTES_MAP[GameType[key as keyof typeof GameType]])
	.filter(Boolean);

export const SLOTS_ROUTES = [
	routes[ROUTE.slotPage].replace('/:slug', ''),
] as const;

// Test IDs used by Hotjar implementation scripts for DOM queries and detection
export const HOTJAR_SCRIPT_TEST_IDS = {
	AUTOBET_BUTTON: 'autobet-button',
	AUTOBET_ACTIVE: 'autobet-active',
	AUTOBET_MODAL: 'autobet-modal',
	FLASHBET_BUTTON: 'flashbet-button',
	FLASHBET_ACTIVE: 'flashbet-active',
	BET_BUTTON: 'bet-button',
	SLOTS_IFRAME: 'slots-iframe',
} as const;

// Test IDs used only for DOM element attributes (not queried by Hotjar scripts)
export const HOTJAR_DOM_TEST_IDS = {
	WALLET_BUTTON: 'wallet-button',

	// HiLo game specific
	HILO_BET_BUTTON: 'hilo-bet-button',
	HILO_DECISION_BUTTON: 'hilo-decision-button',

	// Dice game specific
	DICE_SWITCH_DIRECTION: 'dice-switch-direction-button',
	DICE_RULE_BUTTON: 'dice-rule-button',

	// Keno game specific
	KENO_CLEAR_BUTTON: 'keno-clear-button',

	// Plinko game specific
	PLINKO_LINES_BUTTON: 'plinko-lines-button',
	PLINKO_RISK_BUTTON: 'plinko-risk-button',

	MODAL_CONTAINER: 'modal-container',
} as const;

export const RECORDING_TIMEOUT = 5 * 60 * 1000; // 5 minutes
export const UNIFIED_RESTART_INTERVAL = 5000; // 5 seconds
export const CONSECUTIVE_BET_THRESHOLD = 3;
export const BET_TIME_WINDOW = 10000; // 10 seconds
export const PERIODIC_STATUS_INTERVAL = 30000; // 30 seconds

// Re-enabling constants
export const BETTING_INACTIVITY_THRESHOLD = 30000; // 30 seconds
